import SelectClubWrap from './SelectClubWrap';
export default SelectClubWrap;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/SelectClub/index.ts